import dayjs from "dayjs";

export const getFhirBasicSkeleton = () => {
  return {
    resourceType: "Basic",
    code: {
      coding: [
        {
          system: "http://enliv.com/code/basic-resource-type",
          code: "user.license",
        },
      ],
    },
    subject: {
      reference: `Person/`,
    },
    created: dayjs().format("YYYY-MM-DD"),
    extension: [
      {
        url: "http://enliv.com/license/data",
        valueString: "",
      },
    ],
  };
};
